// extracted by mini-css-extract-plugin
export default {"steps":"Steps_steps__rVrY-"};